/**
 * Polski kalendarz imienin — wszystkie 366 dni roku.
 * Klucze: 'MM-DD', wartości: imiona w dopełniaczu (dla zdania
 * "Dziś są imieniny: Hanny, Joanny").
 *
 * Źródło: utrwalony kościelny/świecki kalendarz imienin 
 * stosowany w Polsce (por. GUS, KAI, roczniki liturgiczne).
 */
const NAME_DAYS: Record<string, string[]> = {
  // ── Styczeń ──────────────────────────────────────────────────
  '01-01': ['Mieszka', 'Mieczysławy', 'Marii'],
  '01-02': ['Izydora', 'Bazylego', 'Grzegorza'],
  '01-03': ['Genowefy', 'Florencji'],
  '01-04': ['Anieli', 'Tytusa'],
  '01-05': ['Szymona', 'Edwarda'],
  '01-06': ['Kacpra', 'Melchiora', 'Baltazara'],
  '01-07': ['Juliana', 'Rajmunda'],
  '01-08': ['Seweryna', 'Eryka'],
  '01-09': ['Marceliny', 'Adelajdy'],
  '01-10': ['Wilhelma', 'Danuty'],
  '01-11': ['Honoraty', 'Feliksa'],
  '01-12': ['Benedykty', 'Arkadiusza'],
  '01-13': ['Bogumiły', 'Weroniki'],
  '01-14': ['Feliksa', 'Niny'],
  '01-15': ['Pawła', 'Arnolda'],
  '01-16': ['Marcela', 'Bereniki'],
  '01-17': ['Antoniego', 'Małgorzaty'],
  '01-18': ['Piotra', 'Wawrzyńca'],
  '01-19': ['Henryka', 'Mariusza'],
  '01-20': ['Fabiana', 'Sebastiana'],
  '01-21': ['Agnieszki', 'Jarosława'],
  '01-22': ['Anastazego', 'Wincentego'],
  '01-23': ['Ildefonsa', 'Rajmunda'],
  '01-24': ['Felicji', 'Franciszka'],
  '01-25': ['Pawła', 'Miłosza'],
  '01-26': ['Pauliny', 'Tymoteusza'],
  '01-27': ['Anieli', 'Jana'],
  '01-28': ['Tomasza', 'Walerego'],
  '01-29': ['Zdzisławy', 'Franciszka'],
  '01-30': ['Martyny', 'Hiacynty'],
  '01-31': ['Marceli', 'Jana'],
  // ── Luty ─────────────────────────────────────────────────────
  '02-01': ['Brygidy', 'Ignacego'],
  '02-02': ['Marii', 'Miłosława'],
  '02-03': ['Błażeja', 'Oskara'],
  '02-04': ['Andrzeja', 'Weroniki'],
  '02-05': ['Agaty', 'Adelajdy'],
  '02-06': ['Doroty', 'Pawła'],
  '02-07': ['Ryszarda', 'Teodora'],
  '02-08': ['Hieronima', 'Piotra'],
  '02-09': ['Apolonii', 'Cyryla'],
  '02-10': ['Scholastyki', 'Jacka'],
  '02-11': ['Eulalii', 'Bernarda'],
  '02-12': ['Eulalii', 'Damiana'],
  '02-13': ['Grzegorza', 'Katarzyny'],
  '02-14': ['Walentego', 'Cyryla', 'Metodego'],
  '02-15': ['Faustyna', 'Jowity'],
  '02-16': ['Juliana', 'Danuty'],
  '02-17': ['Aleksego', 'Donaty'],
  '02-18': ['Szymona', 'Konstancji'],
  '02-19': ['Konrada', 'Mansweta'],
  '02-20': ['Leona', 'Luciany'],
  '02-21': ['Eleonory', 'Roberta'],
  '02-22': ['Marty', 'Małgorzaty'],
  '02-23': ['Romany', 'Damiana'],
  '02-24': ['Macieja', 'Bogusza'],
  '02-25': ['Wiktora', 'Cezarego'],
  '02-26': ['Aleksandra', 'Mirosławy'],
  '02-27': ['Gabriela', 'Leonarda'],
  '02-28': ['Ludomira', 'Makarego'],
  '02-29': ['Hilarego', 'Leandra'],
  // ── Marzec ───────────────────────────────────────────────────
  '03-01': ['Antoniny', 'Albina'],
  '03-02': ['Haliny', 'Heleny'],
  '03-03': ['Kunegundy', 'Maryny'],
  '03-04': ['Kazimierza', 'Łucji'],
  '03-05': ['Adriana', 'Oliwii'],
  '03-06': ['Róży', 'Wiktora'],
  '03-07': ['Tomasza', 'Felicyty'],
  '03-08': ['Beaty', 'Jana'],
  '03-09': ['Franciszki', 'Katarzyny'],
  '03-10': ['Cypriana', 'Aleksandra'],
  '03-11': ['Benedykta', 'Konstantyna'],
  '03-12': ['Grzegorza', 'Maksymiliana'],
  '03-13': ['Krystyny', 'Leandra'],
  '03-14': ['Matyldy', 'Leontyny'],
  '03-15': ['Klemensa', 'Longina'],
  '03-16': ['Izabeli', 'Heriberta'],
  '03-17': ['Patryka', 'Gertrudy'],
  '03-18': ['Cyryla', 'Edwarda'],
  '03-19': ['Józefa', 'Bogdana'],
  '03-20': ['Klaudii', 'Joachima'],
  '03-21': ['Benedykta', 'Lubomiry'],
  '03-22': ['Katarzyny', 'Bogusława'],
  '03-23': ['Pelagii', 'Feliksa'],
  '03-24': ['Gabriela', 'Marka'],
  '03-25': ['Wieńczysławy', 'Marioli'],
  '03-26': ['Larysy', 'Teodora'],
  '03-27': ['Lidii', 'Ernesta'],
  '03-28': ['Sykstusa', 'Jana'],
  '03-29': ['Wiktoryny', 'Helmuta'],
  '03-30': ['Dobromiry', 'Kwiryna'],
  '03-31': ['Beniamina', 'Kornelii'],
  // ── Kwiecień ─────────────────────────────────────────────────
  '04-01': ['Ireny', 'Hugona'],
  '04-02': ['Franciszka', 'Marii'],
  '04-03': ['Ryszarda', 'Benedykta'],
  '04-04': ['Izydora', 'Benedykty'],
  '04-05': ['Ireny', 'Wincentego'],
  '04-06': ['Celestyna', 'Wilhelma'],
  '04-07': ['Donaty', 'Jana'],
  '04-08': ['Cezarego', 'Dionizego'],
  '04-09': ['Marii', 'Dymitra'],
  '04-10': ['Michała', 'Makarego'],
  '04-11': ['Filipa', 'Leona'],
  '04-12': ['Juliusza', 'Zenona'],
  '04-13': ['Hermenegildy', 'Martyny'],
  '04-14': ['Waleriana', 'Lideryki'],
  '04-15': ['Anastazji', 'Wacława'],
  '04-16': ['Bernarda', 'Druzylli'],
  '04-17': ['Rudolfa', 'Roberta'],
  '04-18': ['Apoloniusza', 'Bogusławy'],
  '04-19': ['Tymona', 'Leona'],
  '04-20': ['Agnieszki', 'Czesławy'],
  '04-21': ['Anzelma', 'Feliksa'],
  '04-22': ['Łukasza', 'Kai'],
  '04-23': ['Jerzego', 'Wojciecha'],
  '04-24': ['Horacego', 'Fidelisa'],
  '04-25': ['Marka', 'Jarosławy'],
  '04-26': ['Marzeny', 'Klety'],
  '04-27': ['Zyty', 'Teofila'],
  '04-28': ['Witalisa', 'Ludwiki'],
  '04-29': ['Katarzyny', 'Piotra'],
  '04-30': ['Mariana', 'Donaty'],
  // ── Maj ──────────────────────────────────────────────────────
  '05-01': ['Józefa', 'Filipa'],
  '05-02': ['Atanazego', 'Zygmunta'],
  '05-03': ['Marii', 'Antoniny'],
  '05-04': ['Floriana', 'Moniki'],
  '05-05': ['Ireny', 'Judyty'],
  '05-06': ['Jana', 'Dominiki'],
  '05-07': ['Benedykta', 'Gizeli'],
  '05-08': ['Stanisława', 'Wiktora'],
  '05-09': ['Grzegorza', 'Izydora'],
  '05-10': ['Antoniny', 'Izydora'],
  '05-11': ['Maji', 'Ignacego'],
  '05-12': ['Pankracego', 'Achillesa'],
  '05-13': ['Serwacego', 'Glorii'],
  '05-14': ['Macieja', 'Michała'],
  '05-15': ['Zofii', 'Izydora'],
  '05-16': ['Andrzeja', 'Jana'],
  '05-17': ['Paschalisa', 'Weroniki'],
  '05-18': ['Jana', 'Feliksa'],
  '05-19': ['Piotra', 'Celestyny'],
  '05-20': ['Bernardyna', 'Teodoty'],
  '05-21': ['Tymoteusza', 'Wiktora'],
  '05-22': ['Heleny', 'Rity'],
  '05-23': ['Dezyrego', 'Michała'],
  '05-24': ['Joanny', 'Zuzanny'],
  '05-25': ['Grzegorza', 'Urbana'],
  '05-26': ['Filipa', 'Pauliny'],
  '05-27': ['Jana', 'Augustyna'],
  '05-28': ['Justyny', 'Ingi'],
  '05-29': ['Magdaleny', 'Urszuli'],
  '05-30': ['Ferdynanda', 'Joanny'],
  '05-31': ['Anieli', 'Petroneli'],
  // ── Czerwiec ─────────────────────────────────────────────────
  '06-01': ['Justyna', 'Konrada'],
  '06-02': ['Marceliny', 'Erazma'],
  '06-03': ['Karola', 'Leszka'],
  '06-04': ['Franciszka', 'Kwiryna'],
  '06-05': ['Bonifacego', 'Walburgi'],
  '06-06': ['Norberta', 'Bogumiła'],
  '06-07': ['Roberta', 'Rawiny'],
  '06-08': ['Medarda', 'Wilhelma'],
  '06-09': ['Felicjana', 'Diany'],
  '06-10': ['Małgorzaty', 'Bogumiła'],
  '06-11': ['Barnaby', 'Feliksa'],
  '06-12': ['Jana', 'Leona'],
  '06-13': ['Antoniego', 'Łucji'],
  '06-14': ['Bazylego', 'Elżbiety'],
  '06-15': ['Wita', 'Jolanty'],
  '06-16': ['Benona', 'Aliny'],
  '06-17': ['Laury', 'Alberta'],
  '06-18': ['Marka', 'Elżbiety'],
  '06-19': ['Gerwazego', 'Protazego'],
  '06-20': ['Florentyny', 'Bogny'],
  '06-21': ['Alojzego', 'Radosławy'],
  '06-22': ['Jana', 'Pauliny'],
  '06-23': ['Wandy', 'Zenona'],
  '06-24': ['Jana', 'Emilii'],
  '06-25': ['Łucji', 'Doroty'],
  '06-26': ['Jana', 'Dawida'],
  '06-27': ['Władysława', 'Cyriaka'],
  '06-28': ['Leona', 'Ireneusza'],
  '06-29': ['Piotra', 'Pawła'],
  '06-30': ['Emilii', 'Lucyny'],
  // ── Lipiec ───────────────────────────────────────────────────
  '07-01': ['Haliny', 'Teodoryka'],
  '07-02': ['Marii', 'Ottona'],
  '07-03': ['Tomasza', 'Jacka'],
  '07-04': ['Ulryka', 'Elżbiety'],
  '07-05': ['Antoniego', 'Karoliny'],
  '07-06': ['Dominiki', 'Łucji'],
  '07-07': ['Benedykta', 'Cyryla'],
  '07-08': ['Elżbiety', 'Edgara'],
  '07-09': ['Hieronima', 'Weroniki'],
  '07-10': ['Filipa', 'Amelii'],
  '07-11': ['Benedykta', 'Olgi'],
  '07-12': ['Jana', 'Brunona'],
  '07-13': ['Henryka', 'Sary'],
  '07-14': ['Kamila', 'Bonawentury'],
  '07-15': ['Włodzimierza', 'Henryka'],
  '07-16': ['Marii', 'Eugeniusza'],
  '07-17': ['Aleksego', 'Anety'],
  '07-18': ['Kamila', 'Szymona'],
  '07-19': ['Wincentego', 'Wodzisławy'],
  '07-20': ['Czesława', 'Małgorzaty'],
  '07-21': ['Wawrzyńca', 'Danuty'],
  '07-22': ['Marii', 'Magdaleny'],
  '07-23': ['Brygidy', 'Apolinarego'],
  '07-24': ['Kingi', 'Krystyny'],
  '07-25': ['Jakuba', 'Krzysztofa'],
  '07-26': ['Anny', 'Joachima'],
  '07-27': ['Julii', 'Celestyna'],
  '07-28': ['Wiktora', 'Apolinarego'],
  '07-29': ['Marty', 'Olafa'],
  '07-30': ['Piotra', 'Juliana'],
  '07-31': ['Ignacego', 'Heleny'],
  // ── Sierpień ─────────────────────────────────────────────────
  '08-01': ['Józefa', 'Aldony'],
  '08-02': ['Gustawa', 'Euzebiusza'],
  '08-03': ['Lidii', 'Nikodema'],
  '08-04': ['Dominika', 'Jana'],
  '08-05': ['Oswalda', 'Marii'],
  '08-06': ['Sławy', 'Jakuba'],
  '08-07': ['Kajetana', 'Donata'],
  '08-08': ['Cyryna', 'Emiliana'],
  '08-09': ['Romana', 'Teresy'],
  '08-10': ['Wawrzyńca', 'Blizy'],
  '08-11': ['Klarki', 'Zuzanny'],
  '08-12': ['Hilarii', 'Jolanty'],
  '08-13': ['Hipolita', 'Radzimiry'],
  '08-14': ['Euzebiusza', 'Alfonsa'],
  '08-15': ['Marii', 'Napoleona'],
  '08-16': ['Joachima', 'Stefana'],
  '08-17': ['Jacka', 'Anuncjaty'],
  '08-18': ['Ilony', 'Bronisławy'],
  '08-19': ['Jana', 'Juliusza'],
  '08-20': ['Bernarda', 'Sabiny'],
  '08-21': ['Joanny', 'Pio'],
  '08-22': ['Tymoteusza', 'Marii'],
  '08-23': ['Filipa', 'Róży'],
  '08-24': ['Bartłomieja', 'Jerzego'],
  '08-25': ['Ludwika', 'Luizy'],
  '08-26': ['Marii', 'Zefiryna'],
  '08-27': ['Józefa', 'Moniki'],
  '08-28': ['Augustyna', 'Hermesa'],
  '08-29': ['Jana', 'Sabiny'],
  '08-30': ['Róży', 'Feliksa'],
  '08-31': ['Rajmunda', 'Aidy'],
  // ── Wrzesień ─────────────────────────────────────────────────
  '09-01': ['Bronisławy', 'Idziego'],
  '09-02': ['Stefana', 'Juliana'],
  '09-03': ['Izabeli', 'Grzegorza'],
  '09-04': ['Rozalii', 'Idy'],
  '09-05': ['Doroty', 'Wawrzyńca'],
  '09-06': ['Eugenii', 'Beaty'],
  '09-07': ['Melchiora', 'Reginy'],
  '09-08': ['Marii', 'Adrianny'],
  '09-09': ['Piotra', 'Sergiusza'],
  '09-10': ['Mikołaja', 'Pulcherii'],
  '09-11': ['Jacka', 'Prota'],
  '09-12': ['Gwidona', 'Sylwii'],
  '09-13': ['Jana', 'Eugenii'],
  '09-14': ['Ernesta', 'Anieli'],
  '09-15': ['Nikodema', 'Rolandy'],
  '09-16': ['Korneliusza', 'Edyty'],
  '09-17': ['Roberta', 'Hildegardy'],
  '09-18': ['Ireny', 'Stanisława'],
  '09-19': ['Januarego', 'Konstancji'],
  '09-20': ['Eustachego', 'Faustyny'],
  '09-21': ['Mateusza', 'Hipolita'],
  '09-22': ['Tomasza', 'Maurycego'],
  '09-23': ['Tekli', 'Linusa'],
  '09-24': ['Ruperta', 'Gerarda'],
  '09-25': ['Władysława', 'Aurelii'],
  '09-26': ['Justyny', 'Euzebiusza'],
  '09-27': ['Wincentego', 'Kosmy'],
  '09-28': ['Wacława', 'Liby'],
  '09-29': ['Michała', 'Gabriela', 'Rafała'],
  '09-30': ['Hieronima', 'Honoriusza'],
  // ── Październik ──────────────────────────────────────────────
  '10-01': ['Remigiusza', 'Teresy'],
  '10-02': ['Leodegara', 'Teofila'],
  '10-03': ['Kandydy', 'Gerarda'],
  '10-04': ['Franciszka', 'Rozalii'],
  '10-05': ['Placyda', 'Faustyny'],
  '10-06': ['Brunona', 'Artura'],
  '10-07': ['Marii', 'Justyny'],
  '10-08': ['Brygidy', 'Pelagii'],
  '10-09': ['Dionizego', 'Jana'],
  '10-10': ['Franciszka', 'Gedymina'],
  '10-11': ['Aleksandra', 'Emilii'],
  '10-12': ['Edwina', 'Maksymiliana'],
  '10-13': ['Edwarda', 'Geralda'],
  '10-14': ['Kaliksta', 'Brunona'],
  '10-15': ['Teresy', 'Jadwigi'],
  '10-16': ['Jadwigi', 'Gawła'],
  '10-17': ['Ignacego', 'Wiktora'],
  '10-18': ['Łukasza', 'Juliana'],
  '10-19': ['Piotra', 'Jana'],
  '10-20': ['Ireny', 'Jana'],
  '10-21': ['Urszuli', 'Hilarego'],
  '10-22': ['Filipa', 'Korduli'],
  '10-23': ['Jana', 'Marleny'],
  '10-24': ['Rafała', 'Antoniego'],
  '10-25': ['Maurycego', 'Darii'],
  '10-26': ['Ewarysty', 'Lucyny'],
  '10-27': ['Sabiny', 'Wincentego'],
  '10-28': ['Szymona', 'Judy'],
  '10-29': ['Euzebii', 'Narcyza'],
  '10-30': ['Edmunda', 'Zenobii'],
  '10-31': ['Wolfganga', 'Urbana'],
  // ── Listopad ─────────────────────────────────────────────────
  '11-01': ['Seweryna', 'Wszystkich Świętych'],
  '11-02': ['Karola', 'Bohdana'],
  '11-03': ['Huberta', 'Sylwii'],
  '11-04': ['Karola', 'Olgierda'],
  '11-05': ['Elżbiety', 'Zachariasza'],
  '11-06': ['Leonarda', 'Feliksa'],
  '11-07': ['Ernesta', 'Floriana'],
  '11-08': ['Seweryna', 'Ottona'],
  '11-09': ['Teodora', 'Ursyna'],
  '11-10': ['Leny', 'Andrzeja'],
  '11-11': ['Marcina', 'Bartłomieja'],
  '11-12': ['Błażeja', 'Renaty'],
  '11-13': ['Stanisława', 'Eugeniusza'],
  '11-14': ['Rogera', 'Serafina'],
  '11-15': ['Leopolda', 'Elżbiety'],
  '11-16': ['Edmunda', 'Marka'],
  '11-17': ['Elżbiety', 'Hugona'],
  '11-18': ['Romana', 'Ordona'],
  '11-19': ['Elżbiety', 'Maksymiliana'],
  '11-20': ['Feliksa', 'Rafała'],
  '11-21': ['Konrada', 'Marii'],
  '11-22': ['Cecylii', 'Joanny'],
  '11-23': ['Klemensa', 'Felicyty'],
  '11-24': ['Flory', 'Jana'],
  '11-25': ['Katarzyny', 'Elżbiety'],
  '11-26': ['Konrada', 'Sylwestra'],
  '11-27': ['Maksymiliana', 'Wirgiliusza'],
  '11-28': ['Jakuba', 'Stefana'],
  '11-29': ['Błażeja', 'Saturnina'],
  '11-30': ['Andrzeja', 'Maury'],
  // ── Grudzień ─────────────────────────────────────────────────
  '12-01': ['Blanki', 'Edmunda'],
  '12-02': ['Balbiny', 'Pauliny'],
  '12-03': ['Franciszka', 'Ksawerego'],
  '12-04': ['Barbary', 'Krystiana'],
  '12-05': ['Sabiny', 'Kryspiny'],
  '12-06': ['Mikołaja', 'Emiliana'],
  '12-07': ['Ambrożego', 'Marcina'],
  '12-08': ['Marii', 'Patrycji'],
  '12-09': ['Leokadii', 'Walerii'],
  '12-10': ['Julii', 'Danieli'],
  '12-11': ['Damazego', 'Waldemara'],
  '12-12': ['Aleksandra', 'Joanny'],
  '12-13': ['Łucji', 'Odylii'],
  '12-14': ['Jana', 'Aliny'],
  '12-15': ['Celiny', 'Niny'],
  '12-16': ['Albiny', 'Adeli'],
  '12-17': ['Olimpii', 'Łazarza'],
  '12-18': ['Gracjana', 'Bogusławy'],
  '12-19': ['Dariusza', 'Urbana'],
  '12-20': ['Dominika', 'Bogumiła'],
  '12-21': ['Tomasza', 'Honoraty'],
  '12-22': ['Zenona', 'Franciszki'],
  '12-23': ['Jana', 'Wiktorii'],
  '12-24': ['Adama', 'Ewy'],
  '12-25': ['Anastazji', 'Leona'],
  '12-26': ['Szczepana', 'Dionizego'],
  '12-27': ['Jana', 'Fabioli'],
  '12-28': ['Antoniego', 'Młodzianków'],
  '12-29': ['Tomasza', 'Dawida'],
  '12-30': ['Dawida', 'Rajnera'],
  '12-31': ['Sylwestra', 'Melanii'],
};

/**
 * Zwraca tablicę imion (w dopełniaczu) świętowanych w podanym dniu.
 * @param month – miesiąc 1–12
 * @param day   – dzień 1–31
 * @returns tablica imion w dopełniaczu (pusta gdy brak danych)
 */
export function getNameDayNames(month: number, day: number): string[] {
  const key = `${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
  return NAME_DAYS[key] ?? [];
}
